/**
 * Seguridad de la comanda por local (RES-114): `settings.comandaSecurity`.
 *
 * Los defaults salen de las decisiones del épico multi-mozo: auto-bloqueo a los 2 minutos (D5),
 * token de operador de 10 horas (D5) y "exigir operador" apagado (D6).
 */

export const DEFAULT_COMANDA_SECURITY = {
  staffIdentification: false,
  autoLockMinutes: 2,
  operatorTokenHours: 10,
  requireOperator: false,
};

// Rangos que ofrece el panel; el servidor acepta más (0–480 min, 1–24 h)
export const AUTO_LOCK_MIN = 1;
export const AUTO_LOCK_MAX = 60;
export const TOKEN_HOURS_MIN = 1;
export const TOKEN_HOURS_MAX = 24;

/** Lo guardado en el servidor (puede faltar o estar incompleto) → estado del formulario. */
export const toComandaSecurityForm = (saved) => ({
  ...DEFAULT_COMANDA_SECURITY,
  ...(saved || {}),
});

const num = (value) => (value === '' || value === null ? NaN : Number(value));

/**
 * Valida el formulario antes de guardar.
 * @returns {'autoLockMinutes' | 'operatorTokenHours' | null} clave de error (i18n
 *   `settings.comandaSecurity.errors.<clave>`), o null si es válido
 */
export const validateComandaSecurity = (form) => {
  const minutes = num(form.autoLockMinutes);
  if (!Number.isInteger(minutes) || minutes < AUTO_LOCK_MIN || minutes > AUTO_LOCK_MAX) {
    return 'autoLockMinutes';
  }
  if (form.staffIdentification) {
    const hours = num(form.operatorTokenHours);
    if (!Number.isFinite(hours) || hours < TOKEN_HOURS_MIN || hours > TOKEN_HOURS_MAX) {
      return 'operatorTokenHours';
    }
  }
  return null;
};

/** Lo que se manda a `PATCH /restaurants/{id}/settings`: números reales y sin exigir operador a ciegas. */
export const buildComandaSecurityPayload = (form) => ({
  staffIdentification: Boolean(form.staffIdentification),
  autoLockMinutes: Number(form.autoLockMinutes),
  operatorTokenHours: Number(form.operatorTokenHours),
  // el servidor rechaza requireOperator sin staffIdentification
  requireOperator: Boolean(form.staffIdentification && form.requireOperator),
});

const normalize = (form) => buildComandaSecurityPayload(toComandaSecurityForm(form));

export const isComandaSecurityDirty = (form, saved) =>
  JSON.stringify(normalize(form)) !== JSON.stringify(normalize(saved));

/**
 * Usuarios activos del local, con rol de comanda, que todavía no tienen PIN.
 * @param {Array} users - Respuesta de listOrganizationUsers
 * @param {string} restaurantId
 * @param {Function} roleUsesPin - Predicado de rol (utils/comandaUsers)
 */
export const countUsersWithoutPin = (users, restaurantId, roleUsesPin) =>
  (users || []).filter(
    (user) =>
      user &&
      user.status === 'active' &&
      roleUsesPin(user.role) &&
      (user.allRestaurants === true || (user.restaurants || []).includes(restaurantId)) &&
      !user.hasPin
  ).length;
